import { ChangeEvent, useState, useEffect, useCallback } from 'react';
import { Modal, FormItem, Input } from '@getsynapse/design-system';
import intl from 'react-intl-universal';

type DuplicateFormModalProps = {
  isOpen: boolean;
  onClose: () => void;
  formName?: string;
  formId: string;
  isJsonSchema?: boolean;
  onDuplicate: (
    title: string,
    formId: string,
    redirect: boolean,
    isJsonSchema?: boolean
  ) => void;
};

const DuplicateFormModal = ({
  isOpen,
  onClose,
  formName,
  formId,
  isJsonSchema,
  onDuplicate,
}: DuplicateFormModalProps) => {
  const [title, setTitle] = useState('');

  useEffect(() => {
    setTitle(`${formName} ${intl.get('SETTINGS_PAGE.FORMS.DUPLICATE.COPY')}`);
  }, [formName]);

  const onTitleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => setTitle(event.target.value),
    []
  );

  const handleDuplicate = useCallback(() => {
    onDuplicate(title, formId, true, isJsonSchema);
    onClose();
  }, [formId, isJsonSchema, onClose, onDuplicate, title]);

  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      aria-label='duplicate-form'
      data-cy='duplicate-form_modal'
      title={`${intl.get('SETTINGS_PAGE.FORMS.DUPLICATE.DUPLICATE_FORM')}?`}
      size='medium'
      actionButtons={[
        {
          children: intl.get('SETTINGS_PAGE.FORMS.DUPLICATE.DUPLICATE_FORM'),
          variant: 'primary',
          onClick: handleDuplicate,
          disabled: !title.trim(),
          'data-cy': 'duplicate_save-open',
        },
        {
          children: intl.get(
            'REQUEST_PAGE.TOP_BAR.CREATE_PROJECT_MODAL.CANCEL'
          ),
          variant: 'tertiary',
          onClick: onClose,
          'data-cy': 'duplicate_cancel',
        },
      ]}
    >
      <FormItem
        className='h-16'
        labelProps={{ required: true }}
        label={intl.get('SETTINGS_PAGE.FORMS.DUPLICATE.NEW_NAME')}
      >
        <Input
          className='h-10'
          placeholder={intl.get('SETTINGS_PAGE.FORMS.FORM_TITLE')}
          value={title}
          onChange={onTitleChange}
          data-cy='form-new_name'
        />
      </FormItem>
    </Modal>
  );
};

export default DuplicateFormModal;
